module.exports = __webpack_public_path__ + "static/media/bandeira_amex.43eb5a27.svg";